<template>
  <v-container fluid grid-list-xl data-test="boas-vindas">
    <v-row class="mt-0" no-gutters>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget :enable-header="false">
          <div slot="widget-content" class="pb-10 ma-8">
            <v-row>
              <h1 class="title mb-4 primary--text">Olá! Seja bem-vindo(a)!</h1>
            </v-row>
            <v-row>
              <p class="text-justify">
                O sistema Desenvolva é uma ferramenta tecnológica que tem por
                objetivo facilitar a implantação do Programa de Gestão por
                Competências na Universidade Federal do Ceará.
              </p>
              <p class="text-justify">
                A Gestão por Competências é um modelo de gestão de pessoas
                inovador e estratégico que formaliza o permanente
                desenvolvimento de competências técnicas e comportamentais das
                pessoas, visando o alcance dos objetivos institucionais.
              </p>
              <p class="text-justify">
                Nos ícones abaixo você terá acesso aos módulos do sistema.
              </p>
            </v-row>

            <v-row
              v-for="(linha, index) in linhas"
              :key="index"
              class="justify-center"
            >
              <v-col
                v-for="botao in linha"
                :key="botao.link"
                class="d-flex col-md-auto justify-center"
              >
                <v-btn
                  :class="{ 'disable-events': botao.disabled }"
                  :color="botao.disabled ? 'grey' : 'secondary'"
                  elevation="3"
                  outlined
                  x-large
                  @click="to(botao.link)"
                >
                  <v-icon left size="24">
                    {{ botao.icon }}
                  </v-icon>
                  <span>{{ botao.nome }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';

export default {
  name: 'PaginaInicial',

  components: { VCardWidget },

  data() {
    return {
      linhas: {
        linha1: [
          {
            nome: 'Perfil',
            link: '/perfil',
            icon: 'person',
            disabled: false,
          },
          {
            nome: 'Mapeamento',
            link: '/mapeamento',
            icon: 'widgets',
            disabled: false,
          },
          {
            nome: 'Diagnóstico',
            link: '/diagnostico',
            icon: 'how_to_reg',
            disabled: false,
          },
        ],
        linha2: [
          {
            nome: 'Desempenho',
            link: '/desempenho',
            icon: 'trending_up',
            disabled: false,
          },
          {
            nome: 'Desenvolvimento',
            link: '/desenvolvimento',
            icon: 'rocket',
            disabled: true,
          },
        ],
        linha3: [],
      },
    };
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
  },

  created() {
    if (this.comissao || this.chefia || this.substituicaoChefia) {
      this.linhas.linha2.push({
        nome: 'Monitoramento',
        link: '/monitoramento',
        icon: 'poll',
        disabled: false,
      });
    }
    if (this.comissao) {
      this.linhas.linha3.push({
        nome: 'Gerenciamento',
        link: '/gerenciamento',
        icon: 'list_alt',
        disabled: false,
      });
    }
  },

  methods: {
    to(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.v-btn--outlined {
  border: thin solid #fff;
}

.v-btn.v-size--x-large {
  height: 70px;
  min-width: 240px;
}

.disable-events {
  pointer-events: none;
}
</style>
